module.exports = __webpack_public_path__ + "b2a931c8202f8d7a1e3fa7a8079977a9.pdf";